import { ReactNode } from 'react'

export const PdfDocument = ({ children }: { children: ReactNode }) => {
  return <div className='l-pdf-document'>{children}</div>
}
